import user from '@iez/lib/user/'
import { getClient } from '..'

// Manually call this when user log in
export const setUser = async ({ token, id }) => {
  const client = getClient()
  client.stop()
  client.clearStore()
  await client.resetStore()
  user.token = token
  user.id = id
  user.isReady = true
}

// Manually call this when user log out
export const unsetUser = async () => {
  const client = getClient()
  client.stop()
  client.clearStore()
  await client.resetStore()
  user.token = null
  user.id = null
  user.isReady = true
}
